import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import ChargeConfirmedContMain from "presentation/view/container/ChargeConfirmed/ChargeConfirmedContMain";

CommonEntrypoint(<ChargeConfirmedContMain/>)